
import * as Utils from './savanna_utils.js';

let completeFunctionsAfterLogin = async () => {
	// in here is the only place where we should set the employee code - otherwise when it reloads on every page load it breaks other stuff relying on that employee code
	// builds the links according to logged in user ( A user that isn't logged in cant even call this - access denied)
	try
	{
	
		let res = await Grape.fetches.postJSON('/employee/get_logged_in_employee_id', {});

		if (res.status === 'OK')
			localStorage.setItem('employee_id', res.get_logged_in_employee_id.employee_id);

			let refresh_feature_roles = await Grape.fetches.getJSON('/settings/get_user_features_access', {}); 
		if (refresh_feature_roles.status == 'OK')
		{
			// Manually update the cache with the new feature roles data
			Grape.cache['FeatureRolesLookup'] = refresh_feature_roles.result;
				
			await Grape.cache.refresh('FeatureRolesLookup');//refresh the cache
				
			// call refresh data visible roles with true to force a refresh in the function
			await Utils.refresh_data_visible_roles(true);
		}
	} catch (err) {
		console.error(err);
	}

	if (window.Grape.currentSession.user.username)
		$("#username_login").html(window.Grape.currentSession.user.username);


	// Get user language setting
	get_user_language: {
		let res = await Grape.fetches.getJSON('/api/user_setting/language', {});
		if (res.value && res.value!=null)
		{
			let prevCode = window.currentLanguageCode;
			localStorage.setItem('user_language_setting', res.value);

			// when the loaded value browser is not the same as the user's settings we need to reload
			if (prevCode !== res.value)
			{
				//location.reload();
				return;
			}
		}
		else {
			let prevCode = window.currentLanguageCode;
			localStorage.setItem('user_language_setting', 'en');
			if (prevCode !== 'en')
			{
				//location.reload();
				return;
			}
		}
	}

	// Load language Phrases ( the words are loaded based on the language in user's settings )
	get_language_phrases: {
		let res = await Grape.fetches.postJSON('/general/get_language_phrases', {});
		window.global_language_phrases = {};

		// save the words in a key-value pair
		if (res != null)
		{
			for (let a = 0; a < res.length; a++)
			{
				window.global_language_phrases[res[a].token] = res[a].phrase;
			}
		}

		window.language_loaded = true;
		//translateNavbar();
	}

	// Get all holidays
	get_holidays: {
		let res = await Grape.fetches.postJSON('/leave/get_holidays', {});
		if (res != null)
			parseHolidayDates(res.get_holidays);
	}

	// Get all color combinations
	get_color_combinations: {
		let res = await Grape.fetches.postJSON('/general/get_leave_color_combinations', {});
		generateCSScolorCombinations(res);
	}

	// build the autocomplete dictionaries
	general_dictionary: {
		window.global_AutoComplete_Dictionary = [];

		let option = {
			table: 'dictionary',
			limit: 1000,
			sortfield: 'word',
			sortorder: 'asc',
			filter: [{ value: 'General', op: '=', field: 'book' }]
		};

		let res = await Grape.fetches.getJSON('/api/record/', option)

		if (res.records != null)
		{
			for (let a = 0; a < res.records.length; a++)
			{
				window.global_AutoComplete_Dictionary.push(res.records[a].word);
			}
		}
	}

	// Documents dictionary
	documents_dictionary: {
		window.global_AutoComplete_Dictionary_Documents = [];

		let dict_option = {
			table: 'dictionary',
			limit: 1000,
			sortfield: 'word',
			sortorder: 'asc',
			filter: [{ value: 'Documents', op: '=', field: 'book' }]

		}
		let res = await Grape.fetches.getJSON('/api/record/', dict_option);

		if (res.records != null)
		{
			for (let a = 0; a < res.records.length; a++)
			{
				window.global_AutoComplete_Dictionary_Documents.push(res.records[a].word);
			}
		}
	}

	// Leave Reason dictionary
	leave_reason_dictionary: {
		window.global_AutoComplete_Dictionary_Leave_Reason = [];

		let leave_dict = {
			table: 'dictionary',
			limit: 1000,
			sortfield: 'word',
			sortorder: 'asc',
			filter: [{ value: 'Leave Reason', op: '=', field: 'book' }]
		}

		let res = await Grape.fetches.getJSON('/api/record/', leave_dict);

		if (res.records != null)
		{
			for (let a = 0; a < res.records.length; a++)
			{
				window.global_AutoComplete_Dictionary_Leave_Reason.push(res.records[a].word);
			}
		}
		await Utils.refresh_data_visible_roles();
	}

};

export default completeFunctionsAfterLogin;
